import {
  resolveXlsxFileName,
  triggerBlobDownload,
} from '../../utils/http/responseHelpers';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import qs from 'qs';
import { Status } from '../../models/common/Status';
import { RootState } from '../store';
import { apiClientWithApi } from '../../utils/http';

export interface ReportState {
  status: Status;
}

export interface ReportRequest {
  From: string;
  To: string;
  ClinicIds?: string[];
  SpecializationIds?: string[];
  DoctorIds?: string[];
  States?: string[];
  AttemptStates?: string[];
  Result?: string[];
  Results?: string[];
  Types?: string[];
  NotificationTypes?: string[];
  readonly FormTemplateIds?: string[];
  readonly FormBatchIds?: string[];
  readonly DispensarizationBatchIds?: string[];
  TextSearch?: string;
}

const initialState: ReportState = {
  status: {
    responseLoading: false,
    responseError: null,
    requestSuccess: null,
    requestError: null,
  },
};

const formatDateForFileName = (date: string): string => {
  const [year, month, day] = date.split('-');
  return `${day}.${month}.${year}`;
};

export const getIncomingReport = createAsyncThunk(
  'IncomingReport/getIncomingReport',
  async (request: ReportRequest, { rejectWithValue }) => {
    try {
      const result = request.Result ?? request.Results;
      const types = request.Types ?? request.NotificationTypes;

      const response = await apiClientWithApi.get('task/inbound/report', {
        params: {
          From: request.From,
          To: request.To,
          ClinicIds: request.ClinicIds,
          States: request.States,
          AttemptStates: request.AttemptStates,
          Result: result,
          Types: types,
          FormTemplateIds: request.FormTemplateIds,
          FormBatchIds: request.FormBatchIds,
          DispensarizationBatchIds: request.DispensarizationBatchIds,
          TextSearch: request.TextSearch,
        },
        paramsSerializer: function (params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        },
        responseType: 'blob',
      });

      const fallbackFileName = `journal_${formatDateForFileName(
        request.From,
      )}-${formatDateForFileName(request.To)}.xlsx`;
      const fileName = resolveXlsxFileName(
        response.headers['content-disposition'],
        fallbackFileName,
      );
      triggerBlobDownload(new Blob([response.data]), fileName);

      return fileName;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return rejectWithValue(error.message);
      } else return rejectWithValue('Не удалось получить отчёт!');
    }
  },
);

export const incomingReportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getIncomingReport.pending, (state) => {
        state.status.responseLoading = true;
        state.status.responseError = null;
        return state;
      })
      .addCase(getIncomingReport.fulfilled, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = null;
        return state;
      })
      .addCase(getIncomingReport.rejected, (state) => {
        state.status.responseLoading = false;
        state.status.responseError = 'Не удалось загрузить звонки';
        return state;
      });
  },
});

export default incomingReportSlice.reducer;

export const selectIncomingReportLoading = (state: RootState) =>
  state.incomingReport.status.responseLoading;
